module.exports = __webpack_public_path__ + "img/memory.action.90da040a.png";